import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  LOB_BEHAVIORAL,
  LOB_DENTAL,
  LOB_MEDBH,
  LOB_MEDICAL,
} from '@cigna/chcp/auth/util';
import { DialogUpdateLobPrefComponent } from '../dialog-update-lob-pref/dialog-update-lob-pref.component';
import { User } from '../manage-access.model';

@Component({
  selector: 'cigna-user-lob',
  templateUrl: './user-lob.component.html',
  styleUrls: ['./user-lob.component.scss'],
})
export class UserLobComponent implements OnInit {
  @Input() user: User;
  @Input() canEdit = true;
  @Input() isImpersonator = false;
  hasDualTin = true;

  constructor(public dialog: MatDialog) {}

  LOB_MEDBH = LOB_MEDBH;
  LOB_BEHAVIORAL = LOB_BEHAVIORAL;
  LOB_MEDICAL = LOB_MEDICAL;
  LOB_DENTAL = LOB_DENTAL;

  ngOnInit(): void {
    this.hasDualTin = this.user.tins.some((tin) => tin.lob === LOB_MEDBH);
  }

  openPreferredLOBModel() {
    this.dialog.open(DialogUpdateLobPrefComponent, {
      autoFocus: false,
      width: '700px',
      data: {
        userId: this.user.id,
        lobPref: this.user.lobPref,
        firstName: this.user.firstName,
        lastName: this.user.lastName,
      },
    });
  }
}
